import React, { useEffect, useState } from "react";
import {
  addInventory,
  ASSIGN_STOCK,
  EMPLOYEE_ASSIGN_LIST,
  GET_INVENTORY_DETAILS,
  getTaskDetailsApiInventory,
  PURCHASE_STOCK,
  stockHistoryList,
  stockUpdate,
  updateInventory,
  USE_STOCK,
  useToGetInventory,
} from "../../../repository/taskRepo";
import { PaymentOutlined } from "@mui/icons-material";
import useReduxStore from "../../../hooks/useReduxStore";
import { useNavigate, useParams } from "react-router-dom";
import { addFilter } from "../../../Slices/FiltersSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { ADD_VENDOR, VENDOR_LIST } from "../../../repository/Inventory-repo";
import moment from "moment";
import { getTeamMemberList } from "../../../repository/teamManagementRepo";

const useInventory = () => {
  const [inventoryData, setInventoryData] = useState({
    productName: "",
    category: "",
    brand: "",
    vendor: "",
    quantity: "",
    mrp: "",
    purchasePrice: "",
    stockQuantity: "",
    reorderLevel: "",
    expireDate: null,
  });
  const { selector: InventoryFilter } = useReduxStore("filters");
  const { selector: user } = useReduxStore("auth");
  const inventoryPermission = user?.userInfo?.permission?.inventory;
  const dispatch = useDispatch();
  const [error, setError] = useState({});
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
  const [Count, setCount] = useState(0);
  const [filterAction, setFilterAction] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchInventory, setSearchInventory] = useState(
    InventoryFilter?.Inventory?.filters?.search || ""
  );
  const [stockDetails, setStockDetails] = useState([]);
  const [stockId, setStockId] = useState("");
  const [quantity, setQuantity] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [assignModal, setAssignModal] = useState(false);
  const [vendorModal, setVendorModal] = useState(false);
  const [inventoryId, setInventoryId] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [assignType, setAssignType] = useState(null);
  const [inventoryDetailList, setInventoryDetailList] = useState([]);
  const [formErrorCreatePurchase, setFormErrorCreatePurchase] = useState({});
  const [formErrorAssignStock, setFormErrorAssignStock] = useState({});
  const [errorVendor, setErrorVendor] = useState({});
  const employee_id = user?.userInfo?._id;
  const [statusType, setStatusType] = useState({
    search: InventoryFilter?.Inventory?.filters?.serach,
  });
  const [stockData, setStockData] = useState({
    quantity: "",
  });
  const [stockModal, setStockModal] = useState({
    open: false,
    data: [],
  });
  const cacheTime = { cacheTime: 10000 };
  const navigate = useNavigate();
  const { id, _id, InventoryD_Id } = useParams();

  const isValidVendor = () => {
    const errorObj = {};
    if (!formDataVendor.name?.trim()) {
      errorObj["name"] = "Vendor is required";
    }

    setErrorVendor(errorObj);
    return Object.keys(errorObj).length === 0;
  };

  const handleOpenVendorModal = () => {
    setVendorModal(true);
  };

  // const handleCloseVendorModal = () => {
  //   setVendorModal(false);
  //   handleOpenPurchaseModal();
  // };
  const handleCloseVendorModal = () => {
    setVendorModal(false);
    if (selectedItem) {
      handleOpenPurchaseModal(selectedItem); //reopen with same item data
    }
  };

  const [formDataVendor, setFormDataVendor] = useState({
    name: "",
    address: "",
    gstNumber: "",
  });

  const [formDataCreatePurchase, setFormDataCreatePurchase] = useState({
    purchaseDate: "",
    quantity: null,
    purchasePrice: null,
    price: null,
    vendor: "",
    remarks: "",
  });

  const [formDataAssignStock, setFormDataAssignStock] = useState({
    dateOfAssign: "",
    typeOfAssign: null,
    remarks: "",
    assignQuantity: null,
    employee_id: null,
  });

  const handleChangeCreatePirce = (e) => {
    const { name, value } = e.target;
    setFormDataCreatePurchase((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormErrorCreatePurchase((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleChangeAssignStock = (e) => {
    const { name, value } = e.target;
    setFormDataAssignStock((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormErrorAssignStock((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleChangeVendor = (e) => {
    const { name, value, type, checked } = e.target;

    setFormDataVendor((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrorVendor((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setInventoryData((prevProps) => ({
      ...prevProps,
      [name]: value,
    }));
    if (value) {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const handleInputStockChange = (event) => {
    const { name, value } = event.target;

    setStockData((prevProps) => ({
      ...prevProps,
      [name]: value,
    }));
    if (value) {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // const handleOpenPurchaseModal = (id) => {
  //   setPurchaseModal(true);
  //   setInventoryId(id);
  // };

  //   const handleOpenPurchaseModal = (arg) => {
  //   setPurchaseModal(true);

  //   // If we got the whole item, use it to prefill; else treat as id only
  //   const item = typeof arg === "object" && arg !== null ? arg : null;
  //   const invId = item ? item._id : arg;

  //   setInventoryId(invId);
  //  const today = moment().format("YYYY-MM-DD");
  //   if (item) {
  //     const preselectedVendor =
  //       item?.vendor?._id ||
  //       (typeof item?.vendor === "string" ? item.vendor : "") ||
  //       "";

  //     const preselectedMRP =
  //       item?.mrp ?? item?.price ?? null; // your table uses mrp; modal uses Name="price"

  //     const preselectedPurchasePrice =
  //       item?.purchasePrice ?? null;

  //     setFormDataCreatePurchase((prev) => ({
  //       ...prev,
  //       // keep existing entries (like purchaseDate/quantity) if already typed
  //       vendor: preselectedVendor,
  //       price: preselectedMRP,
  //       purchasePrice: preselectedPurchasePrice,
  //        purchaseDate: today,
  //       // purchaseDate: prev.purchaseDate || moment().format("YYYY-MM-DD"),
  //     }));

  //     // Clear any old field errors for these prefilled values
  //     setFormErrorCreatePurchase((prev) => ({
  //       ...prev,
  //       vendor: "",
  //       price: "",
  //       purchasePrice: "",
  //     }));
  //   }
  // };

  const handleOpenPurchaseModal = (arg) => {
    const item = typeof arg === "object" && arg !== null ? arg : selectedItem;
    if (item) setSelectedItem(item);

    setPurchaseModal(true);
    const invId = item ? item._id : arg;
    setInventoryId(invId);

    const today = moment().format("YYYY-MM-DD");

    if (item) {
      const preselectedVendor =
        item?.vendor?._id ||
        (typeof item?.vendor === "string" ? item.vendor : "") ||
        "";

      const preselectedMRP = item?.mrp ?? item?.price ?? null;
      const preselectedPurchasePrice = item?.purchasePrice ?? null;

      setFormDataCreatePurchase((prev) => ({
        ...prev,
        // Only fill fields that are empty/null, don’t overwrite what user typed
        vendor: prev.vendor || preselectedVendor,
        price: prev.price ?? preselectedMRP,
        purchasePrice: prev.purchasePrice ?? preselectedPurchasePrice,
        purchaseDate: prev.purchaseDate || today,
        quantity: prev.quantity ?? "", // retain typed quantity
        remarks: prev.remarks ?? "", // retain typed remarks
      }));

      setFormErrorCreatePurchase((prev) => ({
        ...prev,
        vendor: "",
        price: "",
        purchasePrice: "",
      }));
    }
  };

  const handleClosePurchaseModal = () => {
    setPurchaseModal(false);
    setInventoryId(null);
    setFormDataCreatePurchase({});
    setFormErrorCreatePurchase({});
  };

  const handleOpenAssignModal = (id, type) => {
    setAssignModal(true);
    setInventoryId(id);
    setAssignType(type);
    const today = moment().format("YYYY-MM-DD");
    setFormDataAssignStock((prev) => ({
      ...prev,
      dateOfAssign: today, // prefill today's date
    }));
    setFormErrorAssignStock({});
  };

  const handleCloseAssignModal = () => {
    setAssignModal(false);
    setInventoryId(null);
    setFormDataAssignStock({});
  };

  useEffect(() => {
    // Dispatch the addFilter action with the current 'Inventory' page and the filter
    dispatch(
      addFilter({
        page: "Inventory",
        filter: {
          search: searchInventory,
          statusType: statusType,
          page: controller?.page,
          rowsPerPage: controller?.rowsPerPage,
        },
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInventory, statusType, controller?.page, controller?.rowsPerPage]);
  let payload = {
    // count: 1000,
    page: controller?.page,
    // rowsPerPage: controller?.rowsPerPage,
    search: statusType?.search,
    count: controller?.rowsPerPage,
  };
  if (typeof statusType == "boolean") payload.isDeleted = statusType;
  else {
    statusType === "false" && (payload.isDeleted = false);
    statusType === "true" && (payload.isDeleted = true);
  }
  // Fetch api
  const {
    data: inventoryList,
    error: inventoryError,
    isFetching: inventoryIsFetching,
    refetch,
  } = useToGetInventory(payload, {
    enabled: false,
    ...cacheTime,
  });
  useEffect(() => {
    refetch();
  }, [controller, filterAction]);

  useEffect(() => {
    vendorListAPI();
    employeeAssignListAPI();
    getInventorydetailsAPi();
  }, []);

  const applayFilter = () => {
    setController({ page: 1, rowsPerPage: 10 });
    refetch();
  };
  const resetFilter = () => {
    setSearchInventory("");
    setStatusType({ search: "" });
    setController({ page: 1, rowsPerPage: 10 });
    setFilterAction((prev) => !prev);
  };
  const isValid = () => {
    const errorObj = {};
    if (!inventoryData?.productName) {
      errorObj["productName"] = "Enter Product Name";
    }

    if (!inventoryData?.category) {
      errorObj["category"] = "Select category";
    }

    // if (!inventoryData?.brand) {
    //     errorObj['brand'] = "Enter brand";
    // }

    // if (!inventoryData?.vendor) {
    //     errorObj["vendor"] = "Enter vendor";
    // }

    // MRP validation
    if (inventoryData?.mrp == null || inventoryData.mrp === "") {
      errorObj["mrp"] = "Enter MRP";
    } else if (Number(inventoryData.mrp) <= 0) {
      errorObj["mrp"] = "MRP should be greater than 0";
    }

    // Purchase Price validation
    if (
      inventoryData?.purchasePrice == null ||
      inventoryData.purchasePrice === ""
    ) {
      errorObj["purchasePrice"] = "Enter purchase price";
    } else if (Number(inventoryData.purchasePrice) <= 0) {
      errorObj["purchasePrice"] = "Purchase price should be greater than 0";
    }

    // Stock Quantity validation
    if (
      inventoryData?.stockQuantity == null ||
      inventoryData.stockQuantity === ""
    ) {
      errorObj["stockQuantity"] = "Enter quantity";
    } else if (Number(inventoryData.stockQuantity) <= 0) {
      errorObj["stockQuantity"] = "Quantity should be greater than 0";
    }

    // Reorder Level
    if (
      inventoryData?.reorderLevel == null ||
      inventoryData.reorderLevel === ""
    ) {
      errorObj["reorderLevel"] = "Enter reorder level";
    }

    // Expiry Date validation
    // if (!inventoryData?.expireDate) {
    //     errorObj['expireDate'] = "Select expiry date";
    // } else {
    //     const today = new Date();
    //     const selectedDate = new Date(inventoryData.expireDate);

    //     today.setHours(0, 0, 0, 0);
    //     selectedDate.setHours(0, 0, 0, 0);

    //     if (selectedDate <= today) {
    //         errorObj['expireDate'] = "Expiry date must be in the future";
    //     }
    // }

    setError(errorObj);
    return Object.keys(errorObj).length === 0;
  };
  const isValidStock = () => {
    const errorObj = {};

    // Check if quantity is empty
    if (!stockData?.quantity && stockData?.quantity !== 0) {
      errorObj["quantity"] = "Enter quantity";
    }
    // Check if quantity is less than or equal to 0
    else if (parseFloat(stockData.quantity) <= 0) {
      errorObj["quantity"] = "Quantity should be greater than 0";
    }

    setError(errorObj);
    return Object.keys(errorObj).length === 0;
  };

  const isValidCreatePurchase = () => {
    const errorObj = {};
    const { vendor } = formDataCreatePurchase;

    if (!vendor) errorObj["vendor"] = "Vendor is required";

    setFormErrorCreatePurchase(errorObj);
    return Object.keys(errorObj).length === 0;
  };

  const isValidTypeOfAssign = () => {
    const errorObj = {};
    const { typeOfAssign } = formDataAssignStock;

    if (!typeOfAssign) errorObj["typeOfAssign"] = "Type of assign is required";

    setFormErrorAssignStock(errorObj);
    return Object.keys(errorObj).length === 0;
  };

  const handlePagination = (obj) => {
    setController(obj);
  };

  const AddInventory = async (e) => {
    e.preventDefault();
    if (!isValid()) return;
    let payload = {
      productName: inventoryData?.productName,
      category: inventoryData?.category,
      brand: inventoryData?.brand || null,
      type: "OTC",
      unit: "Strip",
      expireDate: inventoryData?.expireDate,
      mrp: inventoryData?.mrp,
      purchasePrice: inventoryData?.purchasePrice,
      sellingPrice: 0,
      stockQuantity: inventoryData?.stockQuantity,
      strength: " 500 mg",
      composition: "Paracetamol",
      dosageForm: "Oral",
      reorderLevel: inventoryData?.reorderLevel,
      vendor: inventoryData?.vendor || null,
    };
    setSpinner(true);
    try {
      let response = await addInventory(payload);
      if (response?.code === 200) {
        navigate("/inventory");
        toast.success(response.message);
      }
      //  else {
      // }
      // inventoryList()
      setSpinner(false);
    } catch (error) {
      setSpinner(false);
      // toast.error(error.message)
    }
  };

  const UpdateInventory = async (e) => {
    e.preventDefault();
    if (!isValid()) return;
    let payload = {
      _id: id,
      productName: inventoryData?.productName,
      category: inventoryData?.category,
      brand: inventoryData?.brand || null,
      type: "OTC",
      unit: "Strip",
      expireDate: inventoryData?.expireDate || null,
      mrp: inventoryData?.mrp,
      purchasePrice: inventoryData?.purchasePrice,
      sellingPrice: 0,
      stockQuantity: inventoryData?.stockQuantity,
      strength: " 500 mg",
      composition: "Paracetamol",
      dosageForm: "Oral",
      reorderLevel: inventoryData?.reorderLevel,
      vendor: inventoryData?.vendor || null,
    };
    setSpinner(true);
    try {
      let response = await updateInventory(payload);
      if (response?.code === 200) {
        navigate("/inventory");
        toast.success(response?.message);
      } else if (response?.code === 401) {
        toast.error(response?.message);
      }
      // inventoryList()
      setSpinner(false);
    } catch (error) {
      setSpinner(false);
      toast.error(error.message);
    }
  };
  const AddUpdateStock = async (actionType) => {
    if (!isValidStock()) return false;
    let payload = {
      _id: stockId,
      action: actionType,
      quantity: stockData?.quantity,
    };
    setSpinner(true);
    try {
      let response = await stockUpdate(payload);
      if (response?.code === 200) {
        refetch();
        toast.success(response.message);
        return true;
      } else if (response?.code) {
        toast.error(response?.message);
        return false;
      }
      navigate("/inventory");
      // inventoryList()
      setSpinner(false);
    } catch (error) {
      setSpinner(false);
      toast.error(error.message);
    }
  };
  const getInventorydetails = async () => {
    try {
      setSpinner(true);
      let response = await getTaskDetailsApiInventory(id);
      setInventoryData(response.data);
    } catch (error) {
      toast.error(error.message);
    }
    setSpinner(false);
  };
  const getInventoryStock = async () => {
    try {
      setSpinner(true);
      let response = await getTaskDetailsApiInventory(_id);
      setInventoryData(response.data);
    } catch (error) {
      toast.error(error.message);
    }
    setSpinner(false);
  };
  // const Inventorylist = async () => {
  //     let payload = {
  //         count: 10,
  //         page: 1,
  //         isActive: true,
  //         isDeleted: false,
  //         search: ""
  //     }
  //     try {
  //         setSpinner(true)
  //         let response = await inventoryList(payload)
  //         console.log("inveeeeeeeeeeeee",response?.data)
  //         // setInventoryDetails(response.data)
  //     } catch (error) {
  //         toast.error(error.message)
  //     }
  //     setSpinner(false)
  // }
  // useEffect(() => {
  //     Inventorylist()
  // }, [])
  useEffect(() => {
    if (id) {
      getInventorydetails();
    }
  }, []);
  useEffect(() => {
    if (_id) {
      getInventoryStock();
    }
  }, []);
  const getStockHistoryList = async () => {
    let payload = {
      count: controller?.rowsPerPage,
      page: controller?.page,
      id: _id,
    };
    try {
      setSpinner(true);
      let response = await stockHistoryList(payload);
      setStockDetails(response.data);
      setCount(response?.totalCount);
    } catch (error) {
      toast.error(error.message);
    }
    setSpinner(false);
  };
  useEffect(() => {
    if (_id) {
      getStockHistoryList();
    }
  }, [_id, Count, controller?.page, controller?.rowsPerPage]);

  const addVendor = async () => {
    if (!isValidVendor()) return;
    try {
      let payload = {
        name: formDataVendor.name,
        address: formDataVendor.address,
        gstNumber: formDataVendor.gstNumber,
      };

      setSpinner(true);
      let response = await ADD_VENDOR(payload);
      if (response.code === 200) {
        toast.success(response.message || "Vendor added successfully");
        vendorListAPI();
        handleCloseVendorModal();
        const prevPurchaseData = { ...formDataCreatePurchase };
        setVendorModal(false);
        setFormDataVendor({});
        setErrorVendor({});
        setTimeout(() => {
          setFormDataCreatePurchase(prevPurchaseData); // restore user's typed values
          handleOpenPurchaseModal(selectedItem);
        }, 150);
      } else {
        toast.error(response.message || "Category add failed");
      }
    } catch (error) {
      vendorListAPI([]);
    }
    setSpinner(false);
  };

  const vendorListAPI = async () => {
    try {
      let payload = {
        page: 1,
        count: 1000,
        isActive: true,
        isDeleted: false,
      };

      setSpinner(true);
      let response = await VENDOR_LIST(payload);
      setVendorList(response?.data);
    } catch (error) {
      setVendorList([]);
    }
    setSpinner(false);
  };

  const addPurchaseStock = async () => {
    if (!isValidCreatePurchase()) return;
    try {
      let payload = {
        inventory_id: inventoryId,
        purchaseDate: moment(formDataCreatePurchase.purchaseDate).utc(),
        quantity: Number(formDataCreatePurchase.quantity),
        purchasePrice: Number(formDataCreatePurchase.purchasePrice),
        price: Number(formDataCreatePurchase.price),
        vendor: formDataCreatePurchase.vendor,
        remarks: formDataCreatePurchase.remarks,
      };

      setSpinner(true);
      let response = await PURCHASE_STOCK(payload);
      if (response.code === 200) {
        toast.success(response.message || "Purchase stock added successfully");
        handleClosePurchaseModal();
        setFormDataCreatePurchase({});
        refetch();
      } else {
        toast.error(response.message || "Purchase stock add failed");
      }
    } catch (error) {
      //   inventoryList([]);
    }
    setSpinner(false);
  };

  const employeeAssignListAPI = async () => {
    try {
      let payload = {
        page: 1,
        count: 1000,
        isDeleted: false,
        isActive: true,
      };

      setSpinner(true);
      let response = await getTeamMemberList(payload);
      setEmployeeList(response?.data);
    } catch (error) {}
    setSpinner(false);
  };

  const addAssignStock = async () => {
    if (!isValidTypeOfAssign()) return;
    try {
      let payload = {
        inventory_id: inventoryId,
        dateOfAssign: moment(formDataAssignStock.dateOfAssign).utc(),
        typeOfAssign: formDataAssignStock.typeOfAssign,
        remarks: formDataAssignStock.remarks,
        assignQuantity: Number(formDataAssignStock.assignQuantity),
        employee_id: formDataAssignStock.employee_id,
      };
      setSpinner(true);
      const response = await ASSIGN_STOCK(payload);
      console.log(response, "11111code");

      if (response.code === 200) {
        toast.success(response.message || "Assign stock added successfully");
        handleCloseAssignModal();
        setFormDataAssignStock({});
        refetch();
      } else {
        toast.error(response.message || "Assign stock add failed");
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.message || "Something went wrong");
    } finally {
      setSpinner(false);
    }
  };

  const addUseStock = async () => {
    // if(!isValidTypeOfAssign()) return;
    try {
      let payload = {
        inventory_id: inventoryId,
        dateOfAssign: moment(formDataAssignStock.dateOfAssign).utc(),
        // typeOfAssign: formDataAssignStock.typeOfAssign,
        remarks: formDataAssignStock.remarks,
        assignQuantity: Number(formDataAssignStock.assignQuantity),
      };

      setSpinner(true);
      let response = await USE_STOCK(payload);
      if (response.code === 200) {
        toast.success(response.message || "Use In stock added successfully");
        handleCloseAssignModal();
        setFormDataAssignStock({});
        refetch();
      } else {
        toast.error(response.message || "Use In stock add failed");
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.message || "Something went wrong");
    } finally {
      setSpinner(false);
    }
  };

  const getInventorydetailsAPi = async () => {
    try {
      let payload = {
        inventory_id: InventoryD_Id,
      };

      setSpinner(true);
      let response = await GET_INVENTORY_DETAILS(payload);
      setInventoryDetailList(response?.data);
    } catch (error) {}
    setSpinner(false);
  };

  return {
    data: {
      inventoryData,
      error,
      controller,
      inventoryList,
      statusType,
      stockModal,
      isLoading: spinner || inventoryIsFetching,
      totalCount:
        inventoryError?.message === "No record found"
          ? 0
          : inventoryList?.totalCount || 0,
      inventoryDetails:
        inventoryError?.message === "No record found"
          ? []
          : inventoryIsFetching?.data || [],
      stockData,
      stockDetails,
      stockId,
      Count,
      inventoryPermission: user,
      purchaseModal,
      vendorList,
      formDataCreatePurchase,
      formDataVendor,
      vendorModal,
      assignModal,
      formDataAssignStock,
      employeeList,
      assignType,
      inventoryDetailList,
      formErrorCreatePurchase,
      formErrorAssignStock,
      errorVendor,
    },
    methods: {
      handleInputChange,
      isValid,
      AddInventory,
      setInventoryData,
      UpdateInventory,
      resetFilter,
      applayFilter,
      setStatusType,
      handlePagination,
      setStockModal,
      setStockId,
      setQuantity,
      setStockData,
      AddUpdateStock,
      handleInputStockChange,
      setError,
      handleOpenPurchaseModal,
      handleClosePurchaseModal,
      addPurchaseStock,
      handleChangeCreatePirce,
      handleChangeVendor,
      handleOpenVendorModal,
      handleCloseVendorModal,
      addVendor,
      handleOpenAssignModal,
      handleCloseAssignModal,
      handleChangeAssignStock,
      addAssignStock,
      addUseStock,
      setFormErrorCreatePurchase,
      setFormDataCreatePurchase,
      setFormDataAssignStock,
      setFormErrorAssignStock,
    },
  };
};

export default useInventory;
